<template>
  <div class="container">
    <div class="wrap">
      <div class="header">
        <div class="logo">
          <img src="@/assets/imgs/groupBuying/logo.png" alt="3dm网游加速器">
        </div>
        <div class="user_info">
          <template v-if="token">
            <div class="info">
              <img class='avatar' :src="userInfo.head_image_url" alt="">
              <span>{{userInfo.nick_name || userInfo.user_phone}}</span>
            </div>
            <span class="btn logout"  @click="logout">退出</span>
          </template>
          <template v-else>
            <span class="btn login" @click="openLoginPage">登录</span>
            <span class="btn reg" @click="openLoginPage">注册</span>
          </template>
        </div>
      </div>
      <div class="ad">
        <img src="@/assets/imgs/groupBuying/head.png" alt="快乐开学季 拼团有好礼">
      </div>
      <div class="content">
        <div class="first">
          <div class="top_decoration">
            <img src="@/assets/imgs/groupBuying/top.png" alt="">
          </div>
          <div class="left">
            <img src="@/assets/imgs/groupBuying/left_1.png" alt="">
          </div>
          <div class="right">
            <img src="@/assets/imgs/groupBuying/right_1.png" alt="">
          </div>
          <div class="right2">
            <img src="@/assets/imgs/groupBuying/right_2.png" alt="">
          </div>
          <div class="title">
            <img src="@/assets/imgs/groupBuying/title_1.png" alt="">
          </div>
          <div class="info">
            <template v-if="token">
              <div class="leader">
                <img src="@/assets/imgs/groupBuying/avatar.png" alt="" class="avatar_bg">
                <img v-if="token" :src="userActiveDetail.participant&&userActiveDetail.participant[0].head || defaultAvatar2" alt="" class="avatar">
                <img v-else :src="defaultAvatar" alt="" class="avatar">
                <div class="user_name">{{token ? userActiveDetail.participant&&(userActiveDetail.participant[0].nick_name || userActiveDetail.participant[0].phone) : '请先登录'}}</div>
              </div>
              <div class="plus"></div>
              <div class="member">
                <template  v-if="userActiveDetail.participant&&userActiveDetail.participant.length == 2">
                  <img :src="userActiveDetail.participant[1].head || defaultAvatar2" alt="" class="avatar">
                  <div class="user_name">{{userActiveDetail.participant[1].nick_name || userActiveDetail.participant[1].phone}}</div>
                </template>
                <template v-else>
                  <img src="@/assets/imgs/groupBuying/avatar_2.png" alt="" class="avatar">
                  <div class="user_name">虚位以待</div>
                </template>
              </div>
            </template>
            <template v-else>
              <span class="noToken">您好，请[<span class="login_btn" @click="openLoginPage">登录<span class="line">/</span>注册</span>]</span>
            </template>
            <div class="link_wrap">
              <div class="link_title">拼团链接</div>
              <div class="link" :title="userActiveDetail.group_link">{{token ? userActiveDetail&&userActiveDetail.group_link : '登录后查看拼团链接'}}</div>
              <div class="copy" @click="copyText(userActiveDetail.group_link)">复制拼团链接发送给好友</div>
            </div>
            <div class="success" v-if="isSuccess">恭喜成团！快去享用优惠吧~</div>
          </div>
        </div>
        <div class="second">
          <div class="left">
            <img src="@/assets/imgs/groupBuying/left.png" alt="">
          </div>
          <div class="right">
            <img src="@/assets/imgs/groupBuying/right.png" alt="">
          </div>
          <div class="title">
            <img src="@/assets/imgs/groupBuying/title_2.png" alt="">
          </div>
          <div class="info">
            <div class="card">
              <div class="name">年卡</div>
              <div class="active_price">
                <span class="label">拼团价：</span>
                <span class="price">139元</span>
              </div>
              <div class="ori_price">
                <span class="label">原价：</span>
                <span class="price">{{product.origin_price}}元</span>
                <div class="line"></div>
              </div>
            </div>
            <div class="btn" @click="purchase(product)"></div>
          </div>
        </div>
        <div class="third">
          <div class="top_decoration">
            <img src="@/assets/imgs/groupBuying/top.png" alt="">
          </div>
          <div class="title">
            <img src="@/assets/imgs/groupBuying/title_3.png" alt="">
          </div>
          <div class="info">
            <div class="rule">
              <span v-html="activeInfo.Description" style="white-space: pre-wrap"></span>
            </div>
          </div>
        </div>
      </div>

      <!-- 登录弹窗 -->
      <el-dialog
        title="登录/注册"
        :visible.sync="showLoginDialog"
        width="528px"
        custom-class="login-dialog"
        append-to-body
      >
        <login v-if="showLoginDialog" />
      </el-dialog>

      <!-- 支付弹窗 -->
      <transition name="fade">
        <div class="layer" v-show="layerShow">
          <div class="layer-title">
            <div class="title">充值</div>
            <span class="el-icon-close" @click="closeLayer"></span>
          </div>
          <div class="tips">
            <template v-if="isSuccess">
              <span class="tip">恭喜您成功拼团，当前可享拼团价格</span>
              <span class="tip2">（仅可享受一次拼团价格哦~）</span>
            </template>
            <template v-else>
              <span class="tip">当前暂未拼团成功，成功拼团可享拼团优惠价</span>
              <span class="tip2">快去邀请好友拼团吧~</span>
            </template>
          </div>
          <div class="layer-content">
            <div class="pay-code" @contextmenu.prevent.stop>
              <div
                class="qr-code"
                ref="qrCode"
                :class="{ loading: qrLoading }"
              ></div>
              <div class="scan" v-show="!qrLoading"></div>
              <div class="qr-loading" v-show="qrLoading"></div>
            </div>
            <div class="pay-info">
              <div class="name">
                <span class="label">套餐：</span>
                <span>普通年卡</span>
              </div>
              <h5 class="sum">
                <span class="label">充值金额：</span>
                <span class="icon">¥</span>
                <span class="integer">{{ parseInt(pay_amount) }}</span>
                <span class="float">{{ getPriceFloat(pay_amount) }}</span>
                <span class="discount" v-if="coupon_discount>0">(券后优惠：{{coupon_discount}}元)</span>
              </h5>
              <h5 class="tips">
                打开{{ form.payWay | translateToName(payWays) }}扫码完成支付
              </h5>
              <div class="operate">
                <div class="payWay wechat" :class="form.payWay == 'wx_qrcode' ? 'selected':''" @click="checkPayWay('wx_qrcode')">微信</div>
                <div class="payWay alipay" :class="form.payWay == 'ali_qrcode' ? 'selected':''" @click="checkPayWay('ali_qrcode')">支付宝</div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <div class="layer-shadow" v-show="layerShow" @click="closeLayer"></div>

      <!-- 提示弹窗 -->
      <transition name="fade">
        <div class="layer_tips" v-show="layerShowTips">
          <div class="tips">
            <template v-if="joinSuccess">
              <span class="tip">恭喜你！成功拼团</span>
            </template>
            <template v-else>
              <span class="tip">拼团失败</span>
              <span class="tip2">{{ noSelf ? '自己不能与自己拼团' : '您已与他人拼团，或者好友已与他人拼团'}}</span>
            </template>
          </div>
          <div class="check" @click="closeLayerTips"></div>
        </div>
      </transition>
      <div class="layer-shadow" v-show="layerShowTips" @click="closeLayerTips"></div>

      <!-- 活动结束提示 -->
    <el-dialog
      title="温馨提示"
      :visible.sync="layerShowEnd"
      width="700px"
      custom-class="tips-dialog"
      append-to-body
    >
      <div class="tips">
        <span>活动已结束</span>
        <span>持续关注消息，下次不要错过啦~</span>
        <div class="tip_btn" @click="layerShowEnd = false">确定</div>
      </div>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import Login from "../login/index.vue";
import { getActiveInfo, getUserActiveInfo, join } from '@/api/groupBuying.js'
import { getCouponList } from "@/api/coupons";
import { getProductlist } from "@/api/lucky";
import QRCode from "qrcodejs2";
import {
  getAdvanceOrder,
  getPayQrCode,
  getPayStatus,
} from "@/api/voucherCenter";
export default {
  components: {
    Login
  },
  computed: {
    couponList() {
      const { allCouponList, selectedItem } = this;
      const now = Date.now();
      return allCouponList
        .filter((item) => {
          const supportProducts = JSON.parse(item.support_product || "[]");
          return supportProducts.some((id) => {
            // let lastPrice = this.getLastPrice(selectedItem, item)
            // lastPrice > 0 &&
            return (
              parseInt(id) === selectedItem.ID &&
              now > new Date(item.valid_begin_time).getTime() &&
              now < new Date(item.valid_end_time).getTime()
            );
          });
        })
        .map((it) => ({
          ...it,
          label:
            (it.type === 2 ? `￥${it.discount}` : `${it.discount_rate}折`) +
            `——${it.name}`,
        }));
    },
    token() {
      return this.$store.getters.token
    },
    userInfo() {
      return this.$store.getters.userInfo;
    },
    isVip() {
      return this.userInfo.is_vip;
    },
    showLoginDialog: {
      get() {
        return this.$store.state.app.showLoginDialog;
      },
      set(show) {
        this.$store.commit("app/setShowLogin", show);
      },
    },
    isSuccess(){
      return this.token ? (this.userActiveDetail.participant ? this.userActiveDetail.Number == this.userActiveDetail.participant.length : false) : false
    }
  },
  watch: {
    token(newVal,oldVal){
      if(newVal != oldVal){
        this.getCoupons()
        this.getActive()
      }
    }
  },
  data(){
    return {
      self_key: '',
      noSelf: false,
      joinSuccess: false,
      activeInfo:{},
      userActiveDetail: {},
      allCouponList: [],
      productList: [],
      product: {},
      defaultAvatar: require('@/assets/imgs/groupBuying/avatar_2.png'),
      defaultAvatar2: require('@/assets/imgs/groupBuying/default.png'),
      layerShowTips: false,
      layerShowEnd: false,
      isEnd: false,
      timerId: null,
      qrcode: null,
      qrLoading: false,
      selectedItem: {},
      layerShow: false,
      lastPrice: 0,
      pay_amount: 0,
      coupon_discount: 0,
      form: {
        couponId: 0,
        payWay: "wx_qrcode",
      },
      payWays: [
        { value: "wx_qrcode", label: "微信" },
        { value: "ali_qrcode", label: "支付宝" },
      ],
    }
  },
  async created(){
    window._czc.push('_trackPageview', '/groupBuying', `拼团活动`)
    
    const { key, token } = this.$route.query
    
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    if(flag){
      this.$router.push(`/mobileGroup?key=${key}`)
      return
    }
    if(key){
      localStorage.setItem('key', key)
      this.$router.replace({ query: {} })
    } 
    // 客户端token置换官网token
    if(token){
      this.$store.dispatch('user/swapToken',token).then(() =>{
        this.$router.push('/groupBuying')
      })
    }
    await this.getActive()
    await this.getActiveProduct()
    if(this.token){
      this.getCoupons()
    }
    
  },
  methods: {
    closeLayerTips(){
      this.layerShowTips = false
      this.$router.push('/groupBuying')
      localStorage.removeItem('key')
    },
    // 筛选拼团套餐
    getActiveProduct() {
      getProductlist()
        .then(({ data }) => {
          console.log(data)
          this.productList = data;
          data.forEach(item =>{
            if(item.day == 360 && item.product_type == 2){
              this.product = item
            }
          })
        })
        .catch(() => {});
    },
    // 获取优惠券列表
    getCoupons() {
      getCouponList()
        .then(({ list }) => {
          this.allCouponList = list || [];
          // if (select)
          //   setTimeout(() => {
          //     const firstItem = this.couponList[0];
          //     this.form.couponId = firstItem ? firstItem.id : "";
          //     this.setLastPrice();
          //   });
        })
        .catch(() => {});
    },
    // 登出系统
    logout() {
      this.$store.dispatch('user/removeToken')
      window.localStorage.clear()
    },
    // 打开登录页面
    openLoginPage() {
      this.setShowLogin();
    },
    setShowLogin(show = true) {
      this.$store.commit("app/setShowLogin", show);
    },
    // 获取活动信息
    getActive(){
      getActiveInfo().then(res =>{
        this.activeInfo = res.data || {}
        if(JSON.stringify(this.activeInfo) == '{}'){
          this.layerShowEnd = true
          this.isEnd = true
        }
        // console.log()
        if(new Date(res.data.end_time).getTime() < Date.now()){
          this.layerShowEnd = true
          this.isEnd = true
        }
        if(this.token){
          this.getUserActiveDetail(true)
        }
      })
    },
    // 获取用户拼团信息
    getUserActiveDetail(flag = false){
      if (!this.token && !this.isEnd) {
        this.$confirm("请先登录您的账号！", {
          title: "提示",
        })
          .then(() => {
            this.setShowLogin();
          })
          .catch(() => {});
        return;
      }
      let url = process.env.NODE_ENV == 'production' ? 'https://js.3dmjiasu.com/groupBuying' : 'http://js.vv4j.com/groupBuying'
      let param =  {
        activity_id: this.activeInfo.id,
        link: encodeURI(url)
      }
      getUserActiveInfo(param).then(res =>{
        this.userActiveDetail = res.data
        this.self_key = res.data.group_link.split('key=')[1]
        if(flag){
          const { key } = this.$route.query
          const key_two  = localStorage.getItem('key') || ''
          if(key){
            localStorage.setItem('key', key)
            this.joinTeam(key)
          }else if(key_two){
            localStorage.removeItem('key')
            this.joinTeam(key_two)
          }
        }
      })
    },

    // 参与拼团
    joinTeam(key){
      if(this.isEnd) return
      let param = { key }
      getUserActiveInfo(param).then(({data}) =>{
        if(data.Number == data.participant.length){
          if(this.self_key == key){
            return
          }else{
            // 拼团失败
            this.joinSuccess = false
            this.layerShowTips = true
          }
        }else{
          if(this.self_key == key){
            this.joinSuccess = false
            this.layerShowTips = true
            this.noSelf = true
            return
          }else{
            join(param).then(res =>{
              if(res.data.Number == res.data.participant.length){
                this.joinSuccess = true
                this.layerShowTips = true
              }else{
                this.joinSuccess = false
                this.layerShowTips = true
              }
            }).catch(err =>{
              // this.$message.error('拼团失败')
              this.joinSuccess = false
              this.layerShowTips = true
              if(err.info == 'self'){
                this.noSelf = true
              }else{
                this.noSelf = false
              }
            }).finally(()=>{
              this.getUserActiveDetail()
              this.getCoupons()
            })
          }
        }
      })
    },

    //复制文本
    copyText(text) {
      if (!this.token) {
        this.$confirm("请先登录您的账号！", {
          title: "提示",
        })
          .then(() => {
            this.setShowLogin();
          })
          .catch(() => {});
        return;
      }
      let element = this.createElement(text);
      element.select();
      element.setSelectionRange(0, element.value.length);
      document.execCommand('copy');
      element.remove();
      this.$message.success("复制成功，快去分享给好友吧~");
    },
 
    //创建临时的输入框元素
    createElement(text) {
      let isRTL = document.documentElement.getAttribute('dir') === 'rtl';
      let element = document.createElement('textarea');
      // 防止在ios中产生缩放效果
      element.style.fontSize = '12pt';
      // 重置盒模型
      element.style.border = '0';
      element.style.padding = '0';
      element.style.margin = '0';
      // 将元素移到屏幕外
      element.style.position = 'absolute';
      element.style[isRTL ? 'right' : 'left'] = '-9999px';
      // 移动元素到页面底部
      let yPosition = window.pageYOffset || document.documentElement.scrollTop;
      element.style.top = `${yPosition}px`;
      //设置元素只读
      element.setAttribute('readonly', '');
      element.value = text;
      document.body.appendChild(element);
      return element;
    },

    checkPayWay(e){
      this.form.payWay = e
      this.createPreOrder(this.selectedItem)
    },
    // 购买
    purchase(item) {
      if(this.isEnd){
        return this.layerShowEnd = true
      }
      // console.log(item)
      if (!this.token) {
        this.$confirm("请先登录您的账号！", {
          title: "提示",
        })
          .then(() => {
            this.setShowLogin();
          })
          .catch(() => {});
        return;
      }
      this.layerShow = true;
      this.selectedItem = item
      // 自动选择最优的优惠券
      let index, price
      this.couponList.forEach((it, i) => {
        const cost = this.getLastPrice(item, it)
        if (i === 0 || price > cost) {
          price = cost
          index = i
        }
      })
      this.form.couponId = isNaN(index) ? '' : this.couponList[index].id
      console.log(this.form)
      // this.setLastPrice()
      // console.log(item)
      this.createPreOrder(item);
    },
    // 生成预订单
    createPreOrder(item) {
      this.clearTimerId();
      const {
        // selectedItem: { id, product_name: productName },
        form: { couponId ,payWay },
      } = this;
      let param = {
        product_id: item.ID + "", // 商品id
        product_name: item.product_name, // 商品名称
        order_channel: "官网", // 下单渠道.如果是客户端，请传：加速器客户端，如果是官网，请传：官网
        pay_way: payWay, // 支付方式。如果是支付宝支付，请传：ali_qrcode,如果微信支付，请传：wx_qrcode
        user_id: this.userInfo.user_id,
        coupon_id: couponId || 0,
      };
      this.qrLoading = true;
      getAdvanceOrder(param).then((data) => {
        if (data.success == true) {
          this.pay_amount = data.data.pay_amount
          this.coupon_discount = data.data.coupon_discount
          // localStorage.setItem('order_id', data.data.out_order_sn)
          // 生成二维码
          const outOrderSn = (this.outOrderSn = data.data.out_order_sn);
          this.getPayCode(outOrderSn);
          this.timerId = setInterval(this.payStatus, 3000, outOrderSn);
          // 订单状态查询
          this.payStatus(outOrderSn);
        }
      });
    },
    // 生成二维码
    getPayCode(ordersn) {
      var param = {
        out_order_sn: ordersn, //订单id
      };
      getPayQrCode(param)
        .then((res) => {
          this.qrLoading = false;
          const container = this.$refs.qrCode;
          if (this.qrcode) {
            this.qrcode.makeCode(res.url);
          } else {
            const { width, height } = container.getBoundingClientRect();
            this.qrcode = new QRCode(container, {
              text: res.url,
              width,
              height,
              colorDark: "#000000",
              colorLight: "#ffffff",
              correctLevel: 0,
            });
          }
          container.title = "";
        })
        .catch(() => {
          // this.qrLoading = false
        });
    },
    // 定时查询  订单状态查询
    payStatus(outOrderSn) {
      return new Promise((resolve, reject) => {
        getPayStatus({
          order_number: outOrderSn, //订单id
        })
          .then((data) => {
            if (data.code == 200 && data.status == "已付款") {
              this.paySuccess = true;
              this.payResultShow = true;
              setTimeout(() => {
                this.payResultShow = false;
              }, 3000);
              this.form.couponId = "";
              this.$store.dispatch("user/getUserInfo");
              this.closeLayer()
              this.$message.success('购买成功！')
              this.getLuckyDrawRestCount()
              resolve(true);
            } else if (data.code == 200 && data.status == "订单超时") {
              this.createPreOrder();
              resolve(false);
            } else {
              resolve(false);
            }
          })
          .catch(() => {
            this.paySuccess = false;
            this.payResultShow = true;
            setTimeout(() => {
              this.payResultShow = false;
            }, 3000);
            reject();
          });
      });
    },
    getPriceFloat(price) {
      let match = /(\.\d+)/.exec(price);
      return match ? match[0] : ".00";
    },
    clearTimerId() {
      if (this.timerId) {
        clearInterval(this.timerId);
        this.timerId = null;
      }
    },
    closeLayer() {
      this.clearTimerId();
      this.layerShow = false;
      // 重新获取优惠券
      this.getCoupons();
      this.outOrderSn = "";
    },
    // 计算最终金额
    getLastPrice(item, couponObj) {
      const minPrice = 0.01;
      let nowPrice = this.getNowPrice(item);
      if (isNaN(nowPrice)) return minPrice;
      if (couponObj) {
        switch (couponObj.type) {
          case 1:
            nowPrice *= couponObj.discount_rate / 10;
            break;
          case 2:
            nowPrice -= couponObj.discount;
            break;
        }
      }
      if (nowPrice < minPrice) nowPrice = minPrice;
      return Math.round(nowPrice * 100) / 100;
    },
    setLastPrice() {
      const {
        couponList,
        form: { couponId },
      } = this;
      const couponObj = couponList.find((it) => it.id === couponId);
      this.lastPrice = this.getLastPrice(this.selectedItem, couponObj);
      // console.log(this.lastPrice)
    },
    // 获取当前价格
    getNowPrice(item) {
      console.log(item)
      return this.isVip
        ? item.vip_price || item.product_price
        : item.product_price;
    },
  }
}
</script>

<style lang='scss' scoped>
/deep/ .tips-dialog{
  background: linear-gradient(180deg, #B3411A 0%, #AE3B16 100%);
}
/deep/ .tips-dialog .el-dialog__title,
/deep/ .tips-dialog .el-dialog__headerbtn .el-dialog__close{
  color: #fff;
}
/deep/ .tips-dialog .tips{
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  span{
    font-size: 24px;
  }
  .tip_btn{
    width: 120px;
    padding: 6px;
    text-align: center;
    background: linear-gradient(123deg, #FBDE78 0%, #EA7547 100%);
    border-radius: 50px;
    font-size: 16px;
    cursor: pointer;
    margin-top: 60px;
  }
}
.container{
  width: 100%;
  background: #191919 !important;
  display: flex;
  justify-content: center;
}
.wrap{
  width: 1920px;
  background: #191919;
  .header{
    width: 100%;
    height: 100px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    .logo{
      width: 258px;
      height: 48px;
      margin-left: 50px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .user_info{
      height: 100px;
      display: flex;
      flex-direction: row;
      font-size: 24px;
      .info{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        .avatar{
          border-radius: 50%;
          width: 50px;
          height: 50px;
          margin-right: 8px;
        }
      }
      .btn{
        width: 170px;
        height: 100px;
        line-height: 100px;
        display: block;
        text-align: center;
        cursor: pointer;
      }
      .reg{
        background: #E8761E;
      }
      .logout{
        &:hover{
          color: #E8761E;
        }
      }
    }
  }
  .ad{
    width: 100%;
    img{
      width: 100%;
    }
  }
  .content{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .first{
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      .top_decoration{
        width: 100%;
        img{
          width: 100%;
        }
      }
      .left{
        width: 426px;
        height: 333px;
        position: absolute;
        left: 0;
        top: 380px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .right{
        width: 347px;
        height: 223px;
        position: absolute;
        right: 0;
        top: 64px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .right2{
        width: 290px;
        height: 274px;
        position: absolute;
        right: 0;
        top: 674px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .title{
        width: 1180px;
        margin: 100px 0 60px;
        img{
          width: 100%;
        }
      }
      .info{
        width: 1227px;
        height: 785px;
        background: url('../../assets/imgs/groupBuying/info_bg.png') center/100% 100%;
        display: flex;
        justify-content: space-around;
        position: relative;
        .leader{
          position: absolute;
          top: 136px;
          left: 173px;
          width: 351px;
          height: 360px;
          background: url('../../assets/imgs/groupBuying/leader.png') center/100% 100%;
          color: #fff;
          .avatar_bg{
            position: absolute;
            top: 91px;
            left: 112px;
            width: 129px;
            height: 153px;
          }
          .avatar{
            position: absolute;
            top: 117px;
            left: 113px;
            width: 127px;
            height: 127px;
            border-radius: 50%;
          }
          .user_name{
            position: absolute;
            top: 271px;
            left: 82px;
            width: 196px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 22px;
            text-align: center;
          }
        }
        .plus{
          position: absolute;
          top: 291px;
          left: 594px;
          width: 36px;
          height: 36px;
          background: url('../../assets/imgs/groupBuying/plus.png') center/100% 100%;
        }
        .member{
          position: absolute;
          top: 178px;
          left: 734px;
          width: 280px;
          height: 272px;
          background: url('../../assets/imgs/groupBuying/member.png') center/100% 100%;
          color: #fff;
          .avatar{
            position: absolute;
            top: 84px;
            left: 97px;
            width: 92px;
            height: 92px;
            border-radius: 50%;
          }
          .user_name{
            position: absolute;
            top: 228px;
            left: 46px;
            width: 196px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 22px;
            text-align: center;
          }
        }
        .link_wrap{
          position: absolute;
          bottom: 120px;
          left: 100px;
          width: 1000px;
          display: flex;
          flex-direction: row;
          align-items: center;
          color: #fff;
          font-size: 28px;
          .link{
            font-size: 24px;
            width: 620px;
            margin: 0 10px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .copy{
            font-size: 22px;
            color: #FF6F00;
            cursor: pointer;
          }
        }
        .success{
          position: absolute;
          top: 36px;
          right: 76px;
          font-size: 36px;
          color: #FF6F00;
          font-family: DFPHaiBaoW12-GB-Regular, DFPHaiBaoW12-GB, Microsoft YaHei;
        }
        .noToken{
          color: #fff;
          font-size: 40px;
          font-family: PingFang SC-Bold, PingFang SC , Microsoft YaHei;
          position: absolute;
          top: 268px;
          .login_btn{
            cursor: pointer;
            color: #E8761E;
            .line{
              color: #fff;
            }
          }
        }
      }
    }
    .second{
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      .left, .right{
        position: absolute;
        top: 100px;
        width: 275px;
        height: 711px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .left{
        left: 0;
      }
      .right{
        right: 0;
      }
      .title{
        width: 1180px;
        margin: 80px 0 50px;
        img{
          width: 100%;
        }
      }
      .info{
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        .card{
          width: 737px;
          height: 394px;
          background: url('../../assets/imgs/groupBuying/card_bg.png') center/100% 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          color: #fff;
          padding: 70px 0;
          .name{
            font-size: 44px;
            margin-bottom: 25px;
          }
          .active_price{
            font-size: 46px;
            margin-bottom: 30px;
            .label{
              font-family: PingFang SC-Bold, PingFang SC;
              font-weight: bold;
            }
            .price{
              color: #ED6801;
              font-family: PangMenZhengDao-Regular, PangMenZhengDao, Microsoft YaHei;
            }
          }
          .ori_price{
            font-size: 32px;
            // text-decoration: line-through;
            position: relative;
            .label{
              font-family: PingFang SC-Bold, PingFang SC;
            }
            .price{
              color: #ED6801;
              font-family: PangMenZhengDao-Regular, PangMenZhengDao, Microsoft YaHei;
            }
            .line{
              position: absolute;
              top: 50%;
              left: -8px;
              width: 198px;
              height: 1px;
              background: #FFFFFF;
              border-radius: 29px 29px 29px 29px;
              opacity: 1;
            }
          }
        }
        .btn{
          margin-top: -119px;
          width: 501px;
          height: 327px;
          background: url('../../assets/imgs/groupBuying/buy.png') center/100% 100%;
          cursor: pointer;
          &:hover{
            background: url('../../assets/imgs/groupBuying/buy_hover.png') center/100% 100%;
          }
        }
      }
    }
    .third{
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 150px;
      .top_decoration{
        width: 100%;
        margin-top: 110px;
        img{
          width: 100%;
        }
      }
      .title{
        width: 726px;
        height: 56px;
        margin: 80px 0 50px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .info{
        width: 1247px;
        min-height: 600px;
        background: url('../../assets/imgs/groupBuying/rule_bg.png') center/100% 100%;
        color: #fff;
        padding: 72px 88px;
        .rule{
          font-size: 18px;
        }
      }
    }
  }
}
.layer_tips {
  position: fixed;
  left: 50%;
  top: 50%;
  width: 685px;
  // height: 420px;
  z-index: 10001;
  background: transparent;
  transform: translate(-50%, -50%);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  .tips{
    width: 685px;
    height: 232px;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: url('../../assets/imgs/groupBuying/layer_bg2.png') center/100% 100%;;
    .tip{
      font-size: 36px;
      // font-weight: bold;
      padding: 10px;
    }
  }
  .check{
    width: 311px;
    height: 203px;
    background: url('../../assets/imgs/groupBuying/check.png') center/100% 100%;;
    margin-top: -80px;
    cursor: pointer;
  }
}
.layer {
  position: fixed;
  left: 50%;
  top: 50%;
  width: 700px;
  height: 420px;
  z-index: 10001;
  // background: linear-gradient(180deg, #B3411A 0%, #AE3B16 100%);
  background: url('../../assets/imgs/groupBuying/layer_bg.png') center/100% 100%;
  transform: translate(-50%, -50%);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.5);
  .layer-title {
    position: relative;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    border-bottom: 1px solid rgba(223, 223, 255, 0.08);
    .title {
      color: rgba(255, 255, 255, 0);
    }
    .el-icon-close {
      position: absolute;
      top: 30px;
      right: 40px;
      cursor: pointer;
      color: rgba(255, 255, 255, 1);
      &:hover {
        color: rgba(255, 255, 255, 0.7);
      }
    }
  }
  .tips{
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    .tip{
      font-size: 24px;
      font-weight: bold;
      padding: 10px;
    }
  }
  .layer-content {
    display: flex;
    padding: 38px 0 0 90px;
    .pay-code {
      position: relative;
      width: 213px;
      height: 213px;
      padding: 16px;
      user-select: none;
      background: url("../../assets/imgs/voucherCenter/qr-border2.png")
        no-repeat top left/cover;

      .qr-code {
        width: 181px;
        height: 181px;
        background-color: rgba($color: #000000, $alpha: 0.8);
        &.loading {
          filter: blur(4px);
          cursor: wait;
        }
        /deep/ img{
          width: 100%;
          height: 100%;
        }
      }
      .scan {
        position: absolute;
        top: 6px;
        left: 8px;
        right: 8px;
        height: 16px;
        background: linear-gradient(
          rgba(0, 180, 255, 0.1),
          rgba(0, 180, 255, 0.6)
        );
        animation: move 2s infinite linear;
      }
      .qr-loading {
        position: absolute;
        width: 32px;
        height: 32px;
        z-index: 1;
        left: 90px;
        top: 90px;
        cursor: wait;
        background-size: 32px 32px;
        background-position: center;
        transform-origin: center;
        // transform: translate(-50%, -50%);
        animation: loading 1s infinite linear;
        background-image: url("../../assets/imgs/voucherCenter/loading.png");
      }
    }
    .pay-info {
      flex: 1;
      display: flex;
      padding-left: 50px;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      .name{
        text-align: left;
        color: #F37C20;
        font-weight: bold;
        font-size: 18px;
        margin-bottom: 10px;
        .label{
          color: #fff;
          font-weight: normal;
        }
      }
      .sum {
        text-align: left;
        color: #F37C20;
        font-weight: bold;
        font-size: 18px;
        .label{
          color: #fff;
          font-weight: normal;
        }
        .icon {
          font-size: 20px;
          margin-right: 6px;
        }
        .discount{
          padding-left: 4px;
          font-size: 14px;
          color: #ff6000;
          font-family: Microsoft YaHei;
        }
      }
      .tips {
        margin-top: 20px;
        color: #fff;
      }
      .operate {
        .el-button {
          width: 120px;
          // padding: 10px 25px;
          border-radius: 18px;
          border: none;
          &:hover {
            opacity: 0.9;
          }
          &:active {
            opacity: 0.7;
          }
        }
        .cancel {
          margin-right: 22px;
          background-color: rgba(255, 255, 255, 0.3);
        }
        .comleted {
          background-color: rgba(11, 112, 236, 1);
        }
      }
    }
  }
}
.layer-shadow {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 9999;
  background-color: rgba($color: #000000, $alpha: 0.7);
}
.payWay{
  width: 160px;
  height: 45px;
  line-height: 45px;
  margin-top: 20px;
  border: 1px solid #FAD976;
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: #fff;
  &.wechat::before{
    display: block;
    content: '';
    width: 26px;
    height: 26px;
    background: url('../../assets/imgs/luckyDraw/newyear/weixin.png') no-repeat center/100% 100%;
    margin-right: 6px;
  }
  &.alipay::before{
    display: block;
    content: '';
    width: 26px;
    height: 26px;
    background: url('../../assets/imgs/luckyDraw/newyear/zhifubao.png') no-repeat center/100% 100%;
    margin-right: 6px;
  }
  &.selected{
    background: linear-gradient(123deg, #FBDE78 0%, #EA7547 100%);
    &.wechat::before{
      background: url('../../assets/imgs/luckyDraw/newyear/weixin_s.png') no-repeat center/100% 100%;
    }
    &.alipay::before{
      background: url('../../assets/imgs/luckyDraw/newyear/zhifubao_s.png') no-repeat center/100% 100%;
    }
  }
}

@keyframes move {
  from {
    top: 6px;
  }
  50% {
    top: 190px;
  }
  to {
    top: 6px;
  }
}
@keyframes loading {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}


</style>